export const GET_NEWS = "GET_NEWS";
export const GET_NEWS_BY_ID = "GET_NEWS_BY_ID";
export const NEWS_ERROR = "NEWS_ERROR";
export const UPDATE_NEWS = "UPDATE_NEWS";
export const CREATE_NEWS = "CREATE_NEWS";
export const DELETE_NEWS_BY_ID = "DELETE_NEWS_BY_ID";
export const GET_NEWS_BY_CATEGORY_ID = "GET_NEWS_BY_CATEGORY_ID";
